export default __webpack_public_path__ + "static/media/play_free_now.66b9aef4.png";